<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateForm">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 py-0">
              <upload-image-direct
                @inputChanged="uplodeImg_1"
                model="restaurants"
                title="صورة المتجر"
              ></upload-image-direct>
              <!-- End:: Image -->
            </div>
            <!-- Start:: Image -->

            <!-- Start:: Name -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="data.full_name"
                />
                <label for="name_input" class="form-label">
                  اسم مالك المتجر*
                </label>
              </div>
            </div>
            <!-- End:: Name -->

            <!-- Start:: Email -->
            <!-- <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="email"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.email"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.email") }}*
                </label>
              </div>
            </div> -->
            <!-- End:: Email -->
            <!-- Phone code is taken from the country selected in the sidebar
                 (see getCountries), so there is no field for it here. -->

            <!-- Start:: Phonecode -->
            <!-- <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.phone_code"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.phoneCode") }}*
                </label>
              </div>
            </div> -->
            <!-- End:: Phonecode -->

            <!-- Start:: Phone -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.phone"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.phone") }}*
                </label>
              </div>
            </div>
            <!-- End:: Phone -->
            <!-- start:: trad_name -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="data.trad_name"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.trad_name") }}*
                </label>
              </div>
            </div>
            <!-- End:: trad_name -->
            <!-- start:: commercial_registration_number -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.commercial_registration_number"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.commercial_registration_number") }}*
                </label>
              </div>
            </div>
            <!-- End:: commercial_registration_number -->
            <!-- Start:: Owner Phone -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.owner_phone"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.owner_phone") }}*
                </label>
              </div>
            </div>
            <!-- End:: Owner Phone -->

            <!-- Start:: Accountant Phone -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.accountant_phone"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.accountant_phone") }}
                </label>
              </div>
            </div>
            <!-- End:: Accountant Phone -->

            <!-- Start:: Whatsapp Phone -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.whatsapp_phone"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.whatsapp_phone") }}
                </label>
              </div>
            </div>
            <!-- End:: Whatsapp Phone -->

            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label"> تصنيف المتجر* </label>
                <multiselect
                  v-model="data.place_category"
                  :options="place_categories"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div>

            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label"> تصنيف المطعم </label>
                <multiselect
                  v-model="data.restaurant_specialty"
                  :options="restaurant_specialties"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                ></multiselect>
              </div>
              <div
                class="pr-3"
                style="
                  font-size: 14px;
                  margin-top: -20px;
                  border-radius: 5px;
                  color: orange;
                "
              >
                في حالة ما كان تصنيف المتجر مطعم
              </div>
            </div>
            <!-- <div class="col-lg-6 p-0"></div> -->
            <!-- Start:: Country -->
            <!-- <div class="col-lg-4 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label">
                  {{ $t("forms.labels.country") }}*
                </label>
                <multiselect
                  :loading="!countries.length"
                  v-model="data.country"
                  :options="countries"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                  @input="
                    getCities(data.country.id);
                    getDistricts(data.country.id);
                    data.city = null;
                    data.district = null;
                  "
                ></multiselect>
              </div>
            </div> -->
            <!-- Start:: Country -->

            <!-- Start:: Cities -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label">
                  {{ $t("forms.labels.city") }}*
                </label>
                <multiselect
                  v-model="data.city"
                  :options="cities"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                  @input="
                    getDistricts(data.city.id);
                    data.primary_district = null;
                    data.districts = [];
                  "
                ></multiselect>
              </div>
            </div>
            <!-- Start:: Cities -->

            <!-- Start:: Covered Districts (district_ids multi-select) -->
            <div class="col-lg-6 py-0">
              <div
                class="input_wrapper top_label"
                :class="{ disabled: !data.city }"
              >
                <label class="form-label">
                  {{ $t("forms.labels.districts") }}*
                </label>
                <multiselect
                  v-model="data.districts"
                  :options="districts"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="true"
                  :show-labels="false"
                  :multiple="true"
                  @input="
                    if (
                      data.primary_district &&
                      !data.districts.some(
                        (d) => d.id === data.primary_district.id
                      )
                    ) {
                      data.primary_district = null;
                    }
                  "
                ></multiselect>
                <div
                  v-if="data.districts && data.districts.length"
                  class="selected-districts-prices mt-2"
                >
                  <span
                    v-for="d in data.districts"
                    :key="d.id"
                    class="badge badge-light mr-1 mb-1"
                  >
                    {{ d.name }}
                    <template
                      v-if="
                        d.delivery_price !== undefined &&
                        d.delivery_price !== null
                      "
                    >
                      — {{ d.delivery_price }}
                    </template>
                  </span>
                </div>
              </div>
            </div>
            <!-- End:: Covered Districts -->

            <!-- Start:: Primary District -->
            <div class="col-lg-6 py-0">
              <div
                class="input_wrapper top_label"
                :class="{ disabled: !data.districts || !data.districts.length }"
              >
                <label class="form-label">
                  {{ $t("forms.labels.primary_district") }}*
                </label>
                <multiselect
                  v-model="data.primary_district"
                  :options="data.districts"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                  :disabled="!data.districts || !data.districts.length"
                  @input="centerMarkerOnDistrict"
                ></multiselect>
                <small class="form-text text-muted">
                  {{ $t("forms.labels.primary_district_helper") }}
                </small>
              </div>
            </div>
            <!-- End:: Primary District -->

            <!-- Start:: Selected Districts Map Preview -->
            <div
              class="col-12 py-0"
              v-if="data.districts && data.districts.length"
            >
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  id="autocomplete_ar"
                  placeholder="ابحث على الخريطة"
                  @click="getAddressAr"
                />
              </div>
              <selected-districts-map-preview
                :districts="districtsForMap"
                :marker-position="coordinates_to_edit"
                height="360px"
                @marker-change="updateMarkerPosition"
              ></selected-districts-map-preview>
            </div>
            <!-- End:: Selected Districts Map Preview -->

            <!-- Start:: Password -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="password"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.password"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.password") }}*
                </label>
              </div>
            </div>
            <!-- End:: Password -->

            <!-- Start:: Password  Confirmation-->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="password"
                  class="form-control"
                  v-model.trim="data.password_confirmation"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.confirmPassword") }}*
                </label>
              </div>
            </div>
            <!-- End:: Password  Confirmation-->

            <!-- Start:: Purchase Settlement Method -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label">
                  {{ $t("forms.labels.purchase_settlement_method") }}
                </label>
                <multiselect
                  v-model="data.purchase_settlement_method"
                  :options="purchaseSettlementMethods"
                  label="name"
                  track-by="value"
                  placeholder=" "
                  :searchable="false"
                  :allow-empty="false"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div>
            <!-- End:: Purchase Settlement Method -->

            <!-- Start:: has_on_demand_rider & delivery cost options -->
            <div class="col-12 py-0">
              <v-checkbox
                :label="$t('forms.labels.has_on_demand_rider')"
                v-model="data.has_on_demand_rider"
                color="#783D73"
              ></v-checkbox>

              <div class="row mr-3" v-if="data.has_on_demand_rider">
                <div class="col-md-6 py-0">
                  <v-checkbox
                    :label="$t('forms.labels.delivery_cost_on_client')"
                    v-model="data.delivery_cost_on_client"
                    color="#783D73"
                  ></v-checkbox>
                </div>
                <div class="col-md-6 py-0">
                  <v-checkbox
                    :label="$t('forms.labels.delivery_cost_on_store')"
                    v-model="data.delivery_cost_on_store"
                    color="#783D73"
                  ></v-checkbox>
                </div>
              </div>

              <v-checkbox
                :label="$t('forms.labels.has_website')"
                v-model="data.has_website"
                color="#783D73"
              ></v-checkbox>
            </div>
            <!-- End:: has_on_demand_rider -->

            <template v-if="data.has_website">
              <!-- Start:: primary_color-->
              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="color"
                    class="form-control"
                    v-model.trim="data.primary_color"
                  />
                  <label for="name_input" class="form-label">
                    {{ $t("forms.labels.primary_color") }}
                  </label>
                </div>
              </div>
              <!-- End:: primary_color-->

              <!-- Start:: secondary_color-->
              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="color"
                    class="form-control"
                    v-model.trim="data.secondary_color"
                  />
                  <label for="name_input" class="form-label">
                    {{ $t("forms.labels.secondary_color") }}
                  </label>
                </div>
              </div>
              <!-- End:: secondary_color-->
            </template>

            <!-- Start:: base_fire_price-->
            <div class="col-lg-4 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.base_fire_price"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.base_fire_price") }}
                </label>
              </div>
            </div>
            <!-- End:: base_fire_price-->

            <!-- Start:: price_km-->
            <div class="col-lg-4 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.price_km"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.price_km") }}
                </label>
              </div>
            </div>
            <!-- End:: price_km-->

            <!-- Start:: base_delivery_price-->
            <div class="col-lg-4 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.base_fire_km"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.base_fire_km") }}
                </label>
              </div>
            </div>
            <!-- End:: base_fire_km-->

            <div class="col-12">
              <hr class="my-3" />
            </div>
            <!-- Start:: base_fire_price-->
            <div class="col-lg-4 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.base_fire_price_website"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.base_fire_price") + " " + $t("website") }}
                </label>
              </div>
            </div>
            <!-- End:: base_fire_price-->

            <!-- Start:: price_km-->
            <div class="col-lg-4 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.price_km_website"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.price_km") + " " + $t("website") }}
                </label>
              </div>
            </div>
            <!-- End:: price_km-->

            <!-- Start:: base_delivery_price-->
            <div class="col-lg-4 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.base_fire_km_website"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.base_fire_km") + " " + $t("website") }}
                </label>
              </div>
            </div>
            <!-- End:: base_fire_km-->

            <!-- Start:: service_fee-->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.service_fee"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.service_fee") }}
                </label>
              </div>
            </div>
            <!-- End:: service_fee-->

            <!-- Start:: service_fee_female-->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.service_fee_female"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.service_fee_female") }}
                </label>
              </div>
            </div>
            <!-- End:: service_fee_female-->

            <div class="border py-4">
              <p>مواعيد العمل</p>

              <div class="row" v-for="(work_day, i) in work_days" :key="i">
                <div class="col-lg-12 py-0">
                  <div class="input_wrapper checkbox_input">
                    <v-switch
                      v-model="work_day.enabled"
                      :label="work_day.day.name"
                    ></v-switch>
                  </div>
                </div>
                <template v-if="work_day.enabled">
                  <div
                    class="row"
                    v-for="(time, i2) in work_day.times"
                    :key="i2"
                  >
                    <div class="col-lg-5">
                      <div class="select-wrapper">
                        <div class="input_wrapper my-0 top_label">
                          <label for="" class="form-label"> من </label>
                          <v-menu
                            :ref="(el) => setTimeFromRef(el, i, i2)"
                            v-model="time.time_from_modal"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="time.from"
                                label=" "
                                prepend-icon="mdi-clock-time-four-outline"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                              v-if="time.time_from_modal"
                              v-model="time.from"
                              full-width
                              format="24hr"
                              @click:minute="saveTimeFrom(time.from, i, i2)"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="error"
                                @click="time.time_from_modal = false"
                              >
                                الغاء
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="saveTimeFrom(time.from, i, i2)"
                              >
                                حفظ
                              </v-btn>
                            </v-time-picker>
                          </v-menu>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-5">
                      <div class="select-wrapper">
                        <div class="input_wrapper my-0 top_label">
                          <label for="" class="form-label"> الي </label>
                          <v-menu
                            :ref="(el) => setTimeToRef(el, i, i2)"
                            v-model="time.time_to_modal"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="time.to"
                                label=" "
                                prepend-icon="mdi-clock-time-four-outline"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                              v-if="time.time_to_modal"
                              v-model="time.to"
                              full-width
                              format="24hr"
                              @click:minute="saveTimeTo(time.to, i, i2)"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="error"
                                @click="time.time_to_modal = false"
                              >
                                الغاء
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="saveTimeTo(time.to, i, i2)"
                              >
                                حفظ
                              </v-btn>
                            </v-time-picker>
                          </v-menu>
                        </div>
                      </div>
                    </div>
                    <div class="col-md col-sm-2">
                      <div
                        class="d-flex align-items-center justify-content-center gap-2 h-100"
                      >
                        <button
                          v-if="work_days[i].times.length < 2"
                          type="button"
                          name="append"
                          @click="appendWorkDayRow(i)"
                        >
                          <i class="fas fa-plus-circle"></i>
                        </button>

                        <button
                          v-if="work_days[i].times.length > 1"
                          type="button"
                          name="append"
                          @click="deleteWorkDayRow(i)"
                        >
                          <i class="fas fa-minus-circle"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-lg-4">
                  <upload-image-direct
                    @inputChanged="uplodeImg_2"
                    model="restaurants"
                    title="صورة المتجر من الخارج"
                  ></upload-image-direct>
                </div>
                <div class="col-lg-4">
                  <upload-image-direct
                    @inputChanged="uplodeImg_3"
                    model="restaurants"
                    title="صورة السجل التجاري"
                  ></upload-image-direct>
                </div>
                <div class="col-lg-4">
                  <upload-image-direct
                    @inputChanged="uplodeImg_4"
                    model="restaurants"
                    title="صورة الضريبة المضافة"
                  ></upload-image-direct>
                </div>
              </div>
            </div>

            <!-- START:: MAP -->
            <div class="col-12 fadeIn">
              <div class="col-lg-12 py-0 mt-2">
                <div class="input_wrapper top_label">
                  <textarea
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    v-model="data.location"
                  />
                  <label for="name_input" class="form-label">
                    وصف الموقع
                  </label>
                </div>
              </div>

              <!-- Start:: Is Active -->
              <!-- <div class="col-12 py-0">
                <v-checkbox
                  :label="$t('forms.labels.can_pay_cash_in_website')"
                  v-model="data.can_pay_cash_in_website"
                  color="success"
                ></v-checkbox>
              </div> -->
              <div class="col-12 py-0">
                <h4>{{ $t("forms.labels.can_pay_cash_in_website") }}</h4>
                <v-radio-group
                  v-model="data.can_pay_cash_in_website"
                  row
                  color="#339989"
                >
                  <v-radio
                    label="نعم"
                    :value="1"
                    on-icon="mdi-checkbox-marked"
                    off-icon="mdi-checkbox-blank-outline"
                    color="#339989"
                  ></v-radio>
                  <v-radio
                    label="لا"
                    :value="0"
                    on-icon="mdi-checkbox-marked"
                    off-icon="mdi-checkbox-blank-outline"
                    color="#339989"
                  ></v-radio>
                  <v-radio
                    label="افتراضي"
                    :value="-1"
                    on-icon="mdi-checkbox-marked"
                    off-icon="mdi-checkbox-blank-outline"
                    color="#339989"
                  ></v-radio>
                </v-radio-group>
              </div>
              <!-- End:: Is Active -->
            </div>
            <!-- END:: MAP -->
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="button_style_1" :disabled="btnIsLoading">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",

  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.stores.title"),
          disabled: false,
          href: "/store/show-all",
        },
        {
          text: this.$t("breadcrumb.stores.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== Data To Send
      data: {
        primary_color: "#339989",
        secondary_color: "#339989",
        restaurant_specialty: null,
        avatar: null,
        store_image: null,
        commercial_registration: null,
        vat_picture: null,
        restaurant_picture_from_outside: null,
        full_name: null,
        email: null,
        phone_code: null,
        phone: null,
        country: JSON.parse(localStorage.getItem("zoz_dash_country")),
        nationality: null,
        city: null,
        region: null,
        primary_district: null,
        districts: [],
        password: null,
        password_confirmation: null,
        trad_name: null,
        commercial_registration_number: null,
        owner_phone: null,
        accountant_phone: null,
        whatsapp_phone: null,
        time_from_modal: null,
        from: null,
        from_day: null,
        time_to_modal: null,
        to: null,
        to_day: null,
        place_category: null,
        location: null,
        can_pay_cash_in_website: false,
        base_fire_price: null,
        price_km: null,
        base_fire_km: null,
        purchase_settlement_method: null,
        has_on_demand_rider: false,
        delivery_cost_on_client: false,
        delivery_cost_on_store: false,
        service_fee: null,
        service_fee_female: null,
        has_website: false,
        price_km_website: null,
        base_fire_price_website: null,
        base_fire_km_website: null,
      },
      // START:: MAP
      center: {
        lat: null,
        lng: null,
      },

      // center: {},
      markers: null,
      coordinates_to_edit: { lat: 0, lng: 0 },

      // ========== Fixed Data
      place_categories: [],
      restaurant_specialties: [],
      countries: [],
      cities: [],
      regions: [],
      districts: [],

      work_days: [
        {
          day: {
            value: "saturday ",
            name: "السبت",
          },
          times: [
            {
              from: null,
              to: null,
            },
          ],
          enabled: false,
        },
        {
          day: {
            value: "sunday  ",
            name: "الأحد",
          },
          times: [
            {
              from: null,
              to: null,
            },
          ],
          enabled: false,
        },
        {
          day: {
            value: "monday  ",
            name: "الأثنين",
          },
          times: [
            {
              from: null,
              to: null,
            },
          ],
          enabled: false,
        },
        {
          day: {
            value: "tuesday ",
            name: "الثلاثاء",
          },
          times: [
            {
              from: null,
              to: null,
            },
          ],
          enabled: false,
        },
        {
          day: {
            value: "wednesday ",
            name: "الأربعاء",
          },
          times: [
            {
              from: null,
              to: null,
            },
          ],
          enabled: false,
        },
        {
          day: {
            value: "thursday ",
            name: "الخميس",
          },
          times: [
            {
              from: null,
              to: null,
            },
          ],
          enabled: false,
        },
        {
          day: {
            value: "friday ",
            name: "الجمعة",
          },
          times: [
            {
              from: null,
              to: null,
            },
          ],
          enabled: false,
        },
      ],

      days: [
        {
          value: "Saturday ",
          name: "السبت",
        },
        {
          value: "Sunday  ",
          name: "الأحد",
        },
        {
          value: "Monday  ",
          name: "الأثنين",
        },
        {
          value: "Tuesday  ",
          name: "الثلاثاء",
        },
        {
          value: "Wednesday  ",
          name: "الأربعاء",
        },
        {
          value: "Thursday  ",
          name: "الخميس",
        },
        {
          value: "Friday ",
          name: "الجمعة",
        },
      ],
      timeFromRefs: {},
      timeToRefs: {},
    };
  },
  computed: {
    purchaseSettlementMethods() {
      return [
        {
          value: "CREDIT",
          name: this.$t("forms.labels.purchase_settlement_credit"),
        },
        {
          value: "CASH_ON_PICKUP",
          name: this.$t("forms.labels.purchase_settlement_cash_on_pickup"),
        },
      ];
    },
    // Feeds <selected-districts-map-preview>: the selected covered districts
    // plus which one is the primary district, for drawing their boundaries.
    districtsForMap() {
      return (this.data.districts || []).map((d) => ({
        id: d.id,
        encoded_polygon: d.encoded_polygon,
        is_primary: !!(
          this.data.primary_district && this.data.primary_district.id === d.id
        ),
      }));
    },
  },
  methods: {
    // Drop the location marker in the middle of the primary district's zone
    centerMarkerOnDistrict(district) {
      const center = this.getDistrictCenter(district);
      if (center) this.coordinates_to_edit = center;
    },
    setTimeFromRef(el, dayIndex, timeIndex) {
      if (!this.timeFromRefs[dayIndex]) {
        this.$set(this.timeFromRefs, dayIndex, {});
      }
      this.$set(this.timeFromRefs[dayIndex], timeIndex, el);
    },
    setTimeToRef(el, dayIndex, timeIndex) {
      if (!this.timeToRefs[dayIndex]) {
        this.$set(this.timeToRefs, dayIndex, {});
      }
      this.$set(this.timeToRefs[dayIndex], timeIndex, el);
    },
    appendWorkDayRow(dayIndex) {
      const newTime = {
        from: null,
        to: null,
      };
      this.work_days[dayIndex].times.push(newTime);
    },
    deleteWorkDayRow(dayIndex) {
      if (this.work_days[dayIndex].times.length > 1) {
        this.work_days[dayIndex].times.pop();
      }
    },
    saveTimeFrom(time, dayIndex, timeIndex) {
      if (this.timeFromRefs[dayIndex]?.[timeIndex]) {
        this.timeFromRefs[dayIndex][timeIndex].save(time);
      }
      this.work_days[dayIndex].times[timeIndex].time_from_modal = false;
    },
    saveTimeTo(time, dayIndex, timeIndex) {
      if (this.timeToRefs[dayIndex]?.[timeIndex]) {
        this.timeToRefs[dayIndex][timeIndex].save(time);
      }
      this.work_days[dayIndex].times[timeIndex].time_to_modal = false;
    },
    // END:: UPDATE LOCATION
    updateMarkerPosition(pos) {
      this.coordinates_to_edit = { lat: pos.lat, lng: pos.lng };
    },
    // Centre of a district's boundary (bounding-box centre of its polygon)
    getDistrictCenter(district) {
      if (
        !district ||
        !district.encoded_polygon ||
        typeof google === "undefined" ||
        !google.maps ||
        !google.maps.geometry
      ) {
        return null;
      }
      try {
        const path = google.maps.geometry.encoding.decodePath(
          district.encoded_polygon
        );
        if (!path.length) return null;
        const bounds = new google.maps.LatLngBounds();
        path.forEach((p) => bounds.extend(p));
        const c = bounds.getCenter();
        return { lat: c.lat(), lng: c.lng() };
      } catch (e) {
        return null;
      }
    },
    // ============== Get User Location
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          // this.$axios({
          //   method: "get",
          //   url: `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&key=AIzaSyAITrPfT5r_qmCm_8ekZyPmnebGo8o_r18`,
          // })
          //   .then((res) => {
          //     console.log(res.data.results[0].formatted_address);
          //   })
          //   .catch(() => {});

          this.markers = [
            {
              position: {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              },
            },
          ];
          this.center = this.markers[0].position;

          this.coordinates_to_edit.lat = this.center.lat;
          this.coordinates_to_edit.lng = this.center.lng;
        });
      }
    },

    // START:: G-MAP GET ADDRESS
    getAddressAr() {
      if (typeof google === "undefined" || !google.maps?.places) return;
      var self = this;
      var input = document.getElementById("autocomplete_ar");
      var searchBox = new google.maps.places.SearchBox(input);
      searchBox.addListener("places_changed", function () {
        var places = searchBox.getPlaces();
        if (places.length == 0) {
          return;
        }
        var bounds = new google.maps.LatLngBounds();
        places.forEach(function (place) {
          bounds.extend(place.geometry.location);
          place.geometry.location.lat();
          place.geometry.location.lng();
          place.formatted_address;
          // self.data.address = place.formatted_address;
          // console.log();
          self.coordinates_to_edit = {
            lat: Number(place.geometry.location.lat()),
            lng: Number(place.geometry.location.lng()),
          };
          // self.markers[0].position.lat = place.geometry.location.lat();
          // self.markers[0].position.lng = place.geometry.location.lat();
        });
      });
    },
    // ============ Get Select Lists Data
    getCountries() {
      this.$axios({
        method: "GET",
        url: `country_not_paginated`,
      })
        .then((res) => {
          this.countries = res.data.data.map((item) => {
            return {
              id: item.id,
              name: `${item.name}`,
              phone_code: item.phone_code,
            };
          });
          // Use the phone code of the country pinned in the sidebar
          const sidebarCountry = this.data.country;
          this.data.phone_code =
            this.countries.find((c) => c.id == sidebarCountry?.id) ||
            (sidebarCountry?.phone_code ? sidebarCountry : null);
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    },
    getCities() {
      this.$axios({
        method: "GET",
        url: `city_not_paginated`,
      })
        .then((res) => {
          this.cities = res.data.data.map((item) => {
            return {
              id: item.id,
              name: `${item.name}`,
            };
          });
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    },
    getRegions(cityId) {
      this.$axios({
        method: "GET",
        url: `region_not_paginated`,
        params: {
          city_id: cityId,
        },
      })
        .then((res) => {
          this.regions = res.data.data.map((item) => {
            return {
              id: item.id,
              name: `${item.name}`,
            };
          });
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    },
    getDistricts(cityId) {
      if (!cityId) {
        this.districts = [];
        return;
      }
      this.$axios({
        method: "GET",
        url: `${process.env.VUE_APP_BASE_URL_GENERAL}/district/${cityId}`,
      })
        .then((res) => {
          this.districts = (res.data.data || [])
            .filter((item) => !!item.is_active)
            .map((item) => {
              return {
                id: item.id,
                name: `${item.name}`,
                delivery_price: item.delivery_price,
                encoded_polygon: item.encoded_polygon,
              };
            });
        })
        .catch((error) => {
          console.log(error.response?.data?.message);
        });
    },

    // Uplode Image
    uplodeImg_1(obj) {
      this.data.store_image = obj;
    },
    uplodeImg_2(obj) {
      this.data.restaurant_picture_from_outside = obj;
    },
    uplodeImg_3(obj) {
      this.data.commercial_registration = obj;
    },
    uplodeImg_4(obj) {
      this.data.vat_picture = obj;
    },

    // Validate Data
    validateForm() {
      this.btnIsLoading = true;

      if (!this.data.store_image) {
        this.$iziToast.error({
          timeout: 2000,
          message: "صورة المتجر مطلوبة",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.full_name) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.name"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.phone_code) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.phone_code"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.phone) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.phone"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.phone.length < 9) {
        this.$iziToast.error({
          timeout: 2000,
          message: "رقم الهاتف يجب ان يكون اكبر من 9 ارقام",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.phone.length > 11) {
        this.$iziToast.error({
          timeout: 2000,
          message: "رقم الهاتف يجب ان يكون اقل من 11 رقم",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.trad_name) {
        this.$iziToast.error({
          timeout: 2000,
          message: "الاسم التجاري المطلوب",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.commercial_registration_number) {
        this.$iziToast.error({
          timeout: 2000,
          message: "رقم السجل التجاري مطلوب",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.owner_phone) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.owner_phone"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.place_category) {
        this.$iziToast.error({
          timeout: 2000,
          message: "تصنيف المتجر مطلوب",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.city) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يرجي اختيار المدينة",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.districts || this.data.districts.length === 0) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يرجى اختيار منطقة واحدة على الأقل",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.primary_district) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.primary_district"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.password) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.password"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.password != this.data.password_confirmation) {
        this.$iziToast.error({
          timeout: 2000,
          message: "تاكيد الباسورد يجب  ان يساوي الباسورد",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.work_days.length == 0) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يرجي اختيار أيام العمل",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.work_days.some((day) => day.times.length == 0)) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يرجي اختيار أوقات العمل",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.restaurant_picture_from_outside) {
        this.$iziToast.error({
          timeout: 2000,
          message: "صورة المتجر من الخارج مطلوبة",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.commercial_registration) {
        this.$iziToast.error({
          timeout: 2000,
          message: "صورة السجل التجاري مطلوبة",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.vat_picture) {
        this.$iziToast.error({
          timeout: 2000,
          message: "صورة الضريبة المضافة مطلوبة",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.location) {
        this.$iziToast.error({
          timeout: 2000,
          message: "وصف الموقع مطلوب",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      submit_data.append("store_image", this.data.store_image);
      submit_data.append("trad_name", this.data.trad_name);
      if (this.data.restaurant_specialty) {
        submit_data.append(
          "restaurant_specialty_id",
          this.data.restaurant_specialty.id
        );
      }
      if (this.work_days.length > 0) {
        this.work_days.forEach((work_day, i) => {
          submit_data.append("work_times[" + i + "][day]", work_day.day.value);
          submit_data.append(
            "work_times[" + i + "][enabled]",
            +work_day.enabled
          );
          if (work_day.times.length > 0 && work_day.enabled) {
            work_day.times.forEach((time, index) => {
              submit_data.append(
                "work_times[" + i + "][times][" + index + "][start_time]",
                time.from
              );
              submit_data.append(
                "work_times[" + i + "][times][" + index + "][end_time]",
                time.to
              );
            });
          }
        });
      }
      // submit_data.append("day_from", this.data.from_day.value);
      // submit_data.append("day_to", this.data.to_day.value);
      // submit_data.append("from", this.data.from);
      // submit_data.append("to", this.data.to);
      submit_data.append("owner_phone", this.data.owner_phone);
      if (this.data.accountant_phone) {
        submit_data.append("accountant_phone", this.data.accountant_phone);
      }
      if (this.data.whatsapp_phone) {
        submit_data.append("whatsapp_phone", this.data.whatsapp_phone);
      }
      if (localStorage.getItem("zoz_dash_country")) {
        const country = JSON.parse(localStorage.getItem("zoz_dash_country"));
        submit_data.append("nationality_id", country.id);
        // submit_data.append("country_id", country.id);
      }
      submit_data.append("place_category_id", this.data.place_category.id);
      submit_data.append("full_name", this.data.full_name);
      submit_data.append("phone_code", this.data.phone_code.phone_code);
      submit_data.append("phone", this.data.phone);
      submit_data.append(
        "restaurant_picture_from_outside",
        this.data.restaurant_picture_from_outside
      );
      submit_data.append("vat_picture", this.data.vat_picture);
      submit_data.append(
        "commercial_registration",
        this.data.commercial_registration
      );
      submit_data.append(
        "commercial_registration_number",
        this.data.commercial_registration_number
      );

      if (this.data.city) {
        submit_data.append("city_id", this.data.city.id);
      }
      // if (this.data.region) {
      //   submit_data.append("region_id", this.data.region.id);
      // }
      if (this.data.primary_district) {
        submit_data.append(
          "primary_district_id",
          this.data.primary_district.id
        );
      }
      if (this.data.districts && this.data.districts.length > 0) {
        // Guarantee the primary district is always part of district_ids,
        // even though the primary dropdown is already restricted to the
        // selected covered districts.
        const districtIds = this.data.districts.map((d) => d.id);
        if (
          this.data.primary_district &&
          !districtIds.includes(this.data.primary_district.id)
        ) {
          districtIds.push(this.data.primary_district.id);
        }
        districtIds.forEach((id, index) => {
          submit_data.append(`district_ids[${index}]`, id);
        });
      }
      // submit_data.append("email", this.data.email);
      submit_data.append("location", this.data.location);
      submit_data.append("lat", this.coordinates_to_edit.lat);
      submit_data.append("lng", this.coordinates_to_edit.lng);

      submit_data.append("password", this.data.password);
      submit_data.append(
        "can_pay_cash_in_website",
        +this.data.can_pay_cash_in_website
      );
      submit_data.append(
        "purchase_settlement_method",
        this.data.purchase_settlement_method
          ? this.data.purchase_settlement_method.value
          : "CREDIT"
      );
      submit_data.append("has_on_demand_rider", +this.data.has_on_demand_rider);
      if (this.data.has_on_demand_rider) {
        submit_data.append(
          "delivery_cost_on_client",
          +this.data.delivery_cost_on_client
        );
        submit_data.append(
          "delivery_cost_on_store",
          +this.data.delivery_cost_on_store
        );
      }
      submit_data.append(
        "base_fire_price",
        this.data.base_fire_price != null && this.data.base_fire_price !== ""
          ? this.data.base_fire_price
          : null
      );
      submit_data.append(
        "price_km",
        this.data.price_km != null && this.data.price_km !== ""
          ? this.data.price_km
          : null
      );
      submit_data.append(
        "base_fire_km",
        this.data.base_fire_km != null && this.data.base_fire_km !== ""
          ? this.data.base_fire_km
          : null
      );
      submit_data.append(
        "base_fire_price_website",
        this.data.base_fire_price_website != null &&
          this.data.base_fire_price_website !== ""
          ? this.data.base_fire_price_website
          : null
      );
      submit_data.append(
        "price_km_website",
        this.data.price_km_website != null && this.data.price_km_website !== ""
          ? this.data.price_km_website
          : null
      );
      submit_data.append(
        "base_fire_km_website",
        this.data.base_fire_km_website != null &&
          this.data.base_fire_km_website !== ""
          ? this.data.base_fire_km_website
          : null
      );

      submit_data.append("has_website", +this.data.has_website);

      if (this.data.has_website) {
        submit_data.append("primary_color", this.data.primary_color);
        submit_data.append("secondary_color", this.data.secondary_color);
      }

      submit_data.append(
        "service_fee",
        this.data.service_fee != null && this.data.service_fee !== ""
          ? this.data.service_fee
          : null
      );
      submit_data.append(
        "service_fee_female",
        this.data.service_fee_female != null &&
          this.data.service_fee_female !== ""
          ? this.data.service_fee_female
          : null
      );

      this.$axios({
        method: "POST",
        url: "store",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("addSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/store/show-all" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },

    getPlaceCategories() {
      this.$axios.get("store_category_not_paginated").then((res) => {
        this.place_categories = res.data.data.map((el) => {
          return { id: el.id, name: `${el.name}` };
        });
        // console.log(this.place_categories);
      });
    },
    getRestaurant_specialties() {
      this.$axios.get("restaurant_specialty_not_paginated").then((res) => {
        this.restaurant_specialties = res.data.data.map((el) => {
          return { id: el.id, name: `${el.ar.name} - ${el.en.name}` };
        });
        // console.log(this.place_categories);
      });
    },
    // Empty Form Data
    emptyFormData() {
      this.data.avatar = null;
      this.full_name = null;
      this.email = null;
      this.phone_code = null;
      this.phone = null;
      this.country = null;
      this.city = null;
      this.region = null;
      this.password = null;
      this.password_confirmation = null;
    },
  },

  created() {
    // Default to normal wallet settlement
    this.data.purchase_settlement_method = this.purchaseSettlementMethods[0];
    // Start:: Fire Methods
    this.getLocation();
    this.getPlaceCategories();
    this.getRestaurant_specialties();
    this.getCountries();
    this.getCities();
    // End:: Fire Methods
  },
};
</script>
